<template>
    <div class="p-3 row">
        <input-text class="col-12 col-md-4" label="Versão" :disabled="readonly" v-model="form.versao" ref="versao" required/>
        <input-date-time class="col-12 col-md-4" label="Data de início" :disabled="readonly" v-model="form.dataInicio" ref="" required/>              
        <input-select class="col-12 " label="Tipo de compartilhamento dos resultados" :disabled="readonly" :options="options.tiposCompatilhamentosResultados" v-model="form.compartilhamentoResultado" ref="compartilhamento" required/>

        <div class="col-12" v-if="!readonly">
            <b-button variant="success" v-if="permissao.c" @click="salvar">
                <i class="fa-solid fa-file-code mr-2"></i>
                Gerar XML
            </b-button>
        </div>
        <div class="col-12 mt-3">
            <h6>Lista de XML's Gerados</h6>
            <b-table head-variant="dark" hover :fields="table.fields" :items="itens">
                <template  #cell(actions)="data">
                    <div class="d-inline-flex">
                        <b-button variant="flat-primary" class="mr-2" @click="$emit('download', data.item)"><i class="fa-solid fa-cloud-arrow-down"></i></b-button>
                        <b-button variant="flat-danger" v-if="!readonly && permissao.d" class="mr-2" @click="$emit('deletar', data.item.id)"><i class="fas fa-trash"></i></b-button>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>

import InputText from '@/components/inputs/InputText';
import InputSelect from '@/components/inputs/InputSelect';
import InputDateTime from '@/components/inputs/InputDateTime';

import helpers from '@/common/utils/helpers';

import {FormMixin} from '@/common/mixins/FormMixin';
import {AlertasMixin} from '@/common/mixins/AlertasMixin';
import cloneDeep from 'lodash/cloneDeep';

export default {
    name: 'Aneel3',
    mixins: [FormMixin, AlertasMixin],
    props: {
        itens : {
            default: () => []
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    components: {
        InputText,
        InputSelect,
        InputDateTime
    }, 
    data: () => ({

        form : {
            codigoInterno: "",
            versao: 0,
            dataInicio: "",
            compartilhamentoResultado: ""
        },

        table : {
            fields : [
                { key: "nomeArquivoAWS", label:"Nome do arquivo"},
                { key: "versao", label:"Versão"},
                { key: "dataInicio", label:"Data de inicio",
                    formatter: (value) => helpers.formatarDataBr(value)
                },
                { key: "compartilhamentoResultado", label:"Tipo de compartilhamento",
                    formatter: (value) => helpers.getEnum(value)?.text
                },
                { key: "actions", label:"Ações"},
            ]
        },

        options : {
            tiposCompatilhamentosResultados : helpers.getTiposCompatilhamentosResultados()
        }
    }),
    watch: {
        itens: {
            handler: function(newValue) {
                this.form.versao = newValue.length ? newValue[newValue.length - 1].versao + 1 : 1;
            },
            deep: true,
            immediate: true
        }
    },
    methods : {
        salvar : function(){
            let dia = helpers.formatarData(this.form.dataInicio, 'DD');
            let mes = helpers.formatarData(this.form.dataInicio, 'MM');
            if(dia == 'Data inválida' || mes == 'Data inválida'){
                this.$emit('salvar',this.form)
                return;
            }
                
            if(dia != 1 || mes != 4){
                let form = cloneDeep(this.form);
                form.mensagemConfirmacao = "O projeto de gestão deve iniciar em 1º de abril do ano em que é proposto, deseja prosseguir com a data informada?";
                this.$emit('salvar',form)
            }else{
                this.$emit('salvar',this.form)
            }
                
        }
    },
    computed :{
        readonly :function(){
            return this.$route.name != 'projeto-gestao-proponente-detalhamento' || !this.projetoEditavel
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosGestaoObrigacoesAneel');
        },
    }
}
</script>
<style lang="">
    
</style>